module.exports = __webpack_public_path__ + "img/login-bj.cd5dba89.png";